import { SortOrder } from '@weave/schema-gen-ts/dist/schemas/reviews/shared/v1/review_request.pb';
import {
  Review as ReviewAggregator,
  ReviewSource,
  ReviewComment,
  ReviewsRequest,
  ReviewsResponse,
} from '@weave/schema-gen-ts/dist/schemas/reviews/aggregator/v1/reviews_aggregator.pb';

export type Review = {
  author: string;
  canReply: boolean;
  comments: Comment[];
  dateModified: string;
  datePublished: string;
  id: string;
  rating: number;
  recommendationType: Recommendation;
  review: string;
  siteName: SiteName;
  profileImageUrl: string;
  hasRead: boolean;
  hasReplied: boolean;
};

export type Comment = {
  canDelete: boolean;
  canEdit: boolean;
  canReply: boolean;
  comment: Comment[];
  commentId: string;
  commentText: string;
  commenter: string;
  dateModified: string;
  datePublished: string;
  hasRead: boolean;
  profileImageUrl?: string;
};

export type Mapping = {
  name: string;
  address: string;
  city: string;
  state: string;
  zip: string;
  country: string;
  needsAttention?: boolean;
  setupState?: string;
};

export type Mappings = {
  facebookMapping: Mapping | null | undefined;
  googleMapping: Mapping | null | undefined;
};

export type Settings = {
  locationId: string;
  autoSend: boolean;
  autoSendDelay: number;
  template: string;
  additionalUrl?: string;
  facebookUrl?: string;
  googleUrl?: string;
  siteOrder: Site[];
};

export enum Recommendation {
  None = '',
  Recommended = 'positive',
  NotRecommended = 'negative',
}

export enum Site {
  Google = 'google',
  Facebook = 'facebook',
  Other = 'other', // aka Weave Private Reviews
}

export type SiteString = 'google' | 'facebook' | 'private';

export enum SiteName {
  Google = 'google',
  Facebook = 'facebook',
  Private = 'private',
}

export type AggregatedReviews = {
  needsAttention: needsAttention;
  ratingScores: ratingScores;
  reviews: Review[];
};

export type needsAttention = {
  facebook: boolean;
  google: boolean;
};

export type ratingScores = {
  googleRating: number;
  facebookRating: number;
};

export enum Rating {
  FIVE_STAR = 5,
  FOUR_STAR = 4,
  THREE_STAR = 3,
  TWO_STAR = 2,
  ONE_STAR = 1,
}

export type ReviewCommentPayload = {
  comment?: string;
  id: string;
  site: SiteName;
  locationId?: string;
};

export type ReviewMapping = {
  facebookMapping: Mapping;
  googleMapping: Mapping;
};

export type GoogleIntegrationStatus = {
  needsAttention: boolean;
  validToken: boolean;
  locationState: {
    isDuplicate: boolean;
    isSuspended: boolean;
    isVerified: boolean;
    needsReverification: boolean;
    isPendingReview: boolean;
    isDisabled: boolean;
    isPublished: true;
    isDisconnected: boolean;
    hasPendingVerification: boolean;
  };
  duplicate: {
    locationName: string;
    googleMapsUrl: string;
    access: string;
  };
  url: string;
  newFeaturesReauthRequired: string;
  serviceAccountMissing: string;
};

export type GetGoogleIntegrationStatusResponse = {
  data: {
    facebook: {
      validToken: boolean;
    };
    google: GoogleIntegrationStatus;
  };
};

export { SortOrder, ReviewSource };

export type { ReviewsRequest, ReviewsResponse, ReviewAggregator, ReviewComment };
